import * as React from "react";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { TickerContent } from "../Common/TickerContent";
import { sendAnimationEndEvent } from "../Common/TickerDisplay.events";
import { TickerText } from "./components/TickerText";
import { Wrapper } from "./components/Wrapper";
import { ITickerDisplayDesktop } from "./TickerDisplayDesktop";
import { View } from "../../../../api/api";

export const TickerDisplayDesktopDefaultView = (
  props: ITickerDisplayDesktop
) => {
  const hideTicker = props.hidden || props.view !== View.DEFAULT;

  if (hideTicker) {
    return null;
  }

  return (
    <Wrapper {...props}>
      <TickerText
        data-e2e-id={E2EIdentifier.DESKTOP_TICKER}
        animationStopped={props.animationStopped}
        onAnimationIteration={sendAnimationEndEvent}
      >
        <TickerContent message={props.message} />
      </TickerText>
    </Wrapper>
  );
};
